import styled from 'styled-components';

const FlexColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default FlexColumnContainer;
